// extracted by mini-css-extract-plugin
export var completionBody = "_km-2";
export var completionCard = "_km-0";
export var completionFooter = "_km-3";
export var completionTitle = "_km-1";